import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import backgroundImage from '../Assets/background.png';
import SessionTimer from './SessionTimer';
import FABSidebar from './FabSidebar'; // ✅ Add FAB import

const Layout = () => {
  return (
    <div
      className="h-screen w-screen overflow-auto bg-cover bg-no-repeat bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="w-full max-w-[1440px] mx-auto flex flex-col gap-6 relative">
        {/* ✅ Header always visible on mobile, spaced normally on desktop */}
        <div className="block md:relative fixed md:static top-0 left-0 w-full z-50">
          <Header />
        </div>

        <SessionTimer duration={6 * 60 * 1000} />

        <div className="flex flex-1 flex-col md:flex-row gap-6 mt-[90px] md:mt-0 px-2 sm:px-4">
          {/* Sidebar visible only on md+ */}
          <div className="hidden md:block md:w-[250px]">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="flex-1 flex">
            <Outlet />
          </div>
        </div>
      </div>

      {/* ✅ FAB Sidebar visible only on mobile */}
      <div className="md:hidden">
        <FABSidebar />
      </div>
    </div>
  );
};

export default Layout;
